export const lblEmailOrMobileNumber = "Email or Phone number";//Email or Mobile number";
export const lblPassword = "Password";
export const lblFirstName = "First name";
export const lblLastName = "Last name";
export const lblValidEmailOrPhone = "Enter Valid Email or Phone...";
export const lblEmail = "Email";
export const lblPhone = "Phone";
export const lblCurrentPassword = "Current password";
export const lblNewPasword = "New pasword";
export const lblConfirmPasword = "Confirm new password";
export const lblLastTransaction = "Last Transaction";
export const lblWalletsAmount = "Wallets Amount";
export const lblTotalIncome = "Total Income";
export const lblTotalSaves = "Total Saves";
export const lblPlumbing = "Plumbing";
export const lblElectrical = "Electrical";
export const lblLandscaping = "Landscaping";
export const hintCurrentPassword = "Enter Current Password";
export const hintNewPassword = "Enter New Password";
export const hintConfirmPassword = "Confirm your password";
export const lblTotalBalance = "Total Balance";
export const lblEarnings = "Earnings";
export const lblLastMonth = "/ month";
export const lblPhoneNumber = "Phone Number";
export const lblAddress = "Address";
export const lblCompanyName = "Company Name";
export const lblCompanyAddress = "Company Address";
export const lblExpertise = "Expertise";
export const lblDiscussion = "Discussion";
export const hintAddComments = "Add Some Comments";
export const lblMessage = "Message";
export const hintTypeComments = "Type Comments";
export const lblOr = "OR CONTINUE WITH";
export const lblAddComments = "Add Some Comments";
export const lblEnterEmailOrPhone = "Enter Email Or Phone";
export const lblTypeComments = "Type comments...";
export const lblWriteMessage = "Write a message...";
export const txtWelcome = "Welcome";
export const txtJoinAs = "Join As";
export const txtForgotPassword = "Forgot password?";
export const txtSelectWhich = "Please enter your email address or phone number to search for your account.";
export const txtEnterVerification = "Enter Verification Code";
export const txtAVerification = "A Verification Code As Been Sent To Your Mobile Phone Or Email";
export const txtChangePassword = "Change Password";
export const txtWordsLeft = "%@ words left";
export const txtAvailable = "Available Jobs";
export const txtActualTip = "Actual Tip";
export const txtChoose = "Choose The Option To Accept Or Decline Job";
export const txtNotifications = "Notifications";
export const txtNesMessages = "%@ new messages";
export const txtNoNotifications = "No Notifications";
export const txtYouHave = "You Have No Notifications At This Time Thank You";
export const txtProfile = "Profile";
export const txtYourPayment = "Your Payment Information";
export const txtInviteFriends = "Invite Friends";
export const txtHowWe = "How We Help Your Industry";
export const txtCallHistory = "Call History";
export const txtCallDetails = "Call Details";
export const txtName = "Name";
export const txtCity = "City";
export const txtState = "State";
export const txtCreatedTime = "Created Time";
export const txtCreatedBy = "Created By";
export const txtCreatedOn = "Created On";
export const txtSentMessage = "Sent Message";
export const txtJoinVideo = "Join Video";
export const txtResendLink = "Resend Link";
export const txtTicketId = "Service Id";
export const txtProduct = "Product Type";
export const txtDescription = "Description";
export const txtUpdated = "Updated On";
export const txtStatus = "Status";
export const txtPhotos = "Choose Photo";
export const txtSendVideoLink = "Send Video Link";
export const txtVideo = "Video";
export const txtChat = "Chat";
export const txtMessages = "Messages can only be seen by people in the call and are deleted when the call ends";
export const txtWrite = "Write a message...";
export const txtEmail = "Email";
export const txtPhoneNumber = "Phone Number";
export const txtDiscussion = "Discussion";
export const txtAddSome = "Add some comments";
export const txtEnterEmailOrPhone = "Email or Phone number";
export const txtMessage = "Message";
export const txtTypeComments = "Type comments...";
export const txtWhyToUse = "Why to use this";
export const txtAnEasyIntuitive = "An Easy, Intuitive User Experience. Help your customers get to the bottom of home service issues with intelligent remote diagnostic solutions. ";
export const lblProfName = "Prof Name";
export const hintProfName = "Enter Prof Name";
export const hintRepairSuggestion = "Enter Repair Suggestion";
export const lblRepairSuggestion = "Repair Suggestion";
export const hintToolsSupplies = "Enter Tools & Supplies Needed For Repair";
export const lblToolsSupplies = "Tools & Supplies Needed For Repair";
export const hintEstimatedCostRepair = "Enter Estimated Cost Of Repair";
export const lblEstimatedCostRepair = "Estimated Cost Of Repair";
export const hintEnterProblemDescription = "Enter Problem Description";
export const lblEnterProblemDescription = "Problem Description";
export const lblAppVersion = "App Version";
export const lblApiVersion = "Api Version";
export const lblOperatingSystemDetails = "Operating System Details";
export const lblPlatform = "Platform";
export const lblFeedbackMessage = "Feedback Message";
export const lblPageDetail = "Page Detail";
export const lblCountry = "Country";
export const txtAppLanguage = "App language";
export const btnSaveChanges = "SAVE CHANGES";
export const txtSelectCountryCode = "Select country code";
export const btnContinue = "CONTINUE";
export const lblStates = "States";
export const txtFoundDevice = "Found Device";
export const txtServicePrefrences = "Service Preferences";
export const txtEnterYourDeviceProb = "Enter here your device problem with more detail,so our expertise will better help you or assist you or fixed your problem";
export const txtAdditionalInformation = "Additional Information:";
export const lblProductModelNo = "Product Model No";
export const lblCommunicationMode = "Communication Mode";
export const lblTimeSlot = "Time Slot";
export const lblProfessionalInfo = "Professional Info";
export const txtSearchAddress = "Search Address...";
export const txtMainInfo = "Main Info";
export const txtSearchCompanyAddress = "Search company address...";
export const txtPleaseAddExpertise = "Please add your expertise.";
export const txtExpertiseDetails = "Expertise details";
export const txtAddExpertise = "Add your expertise";
export const txtEditExpertise = "Edit your expertise";
export const txtExpertiseDeleteConfirmation = "Are you sure you want to delete this expertise?";
export const txtExpertiseName = "Your expertise";
export const txtExpertiseCompetency = "Expertise competency";
export const txtWorkExperience = "Work experience";
export const txtExpInExpertise = "Experience in expertise";
export const txtCertified = "Certified";
export const txtCertificate = "Certificate";
export const txtCertification = "Certification";
export const txtLicenceOne = "Licence 1";
export const txtLicenceTwo = "Licence 2";
export const txtLicenceThree = "Licence 3";
export const txtInsurance = "Insurance";
export const txtUploadedDocuments = "Uploaded Documents";
export const txtAccountNumber = "Account Number";
export const txtIFSCCode = "IFSC Code";
export const txtAccountHolderName = "Account Holder Name";
export const txtServiceRequests = "My requests";
export const txtServiceID = "Service ID";
export const txtDateTime = "Date-Time";
export const txtCategory = "Category";
export const txtDashboard = "Dashboard";
export const txtCreatedDate = "Created Date";
export const txtRole = "Role";
export const txtLastLogin = "Last Login";
export const txtAction = "Action";
export const txtNoRecordsFound = "No Records Found";
export const txtYourLogin = "Your login in Chilll";
export const txtHelp = "Help";
export const txtTipsTricks = "Tips & Tricks";
export const btnLearnTipsTricks = "Learn tips & tricks";
export const btnNext = "Next";
export const btnSaveAccountInfo = "SAVE ACCOUNT INFO";
export const txtDeleteAccountConfirmation = "Are you sure that you want to delete your account in Chilll?";
export const txtDeleteAccountSubConfirmation = " Deleting your account is not reversible once the process is complete. If you are certain you wish to delete your account, type your login in the field below.";
export const txtUserDetails = "User Details";
export const txtUserName = "User Name";
export const txtWaitingList = "Waiting List";
export const txtFullName = "Full Name";
export const txtSignUpAs = "Sign-up as a...";
export const txtFeedbackList = "Feedback List";
export const txtFeedbackDetails = "Feedback Details";
export const txtRoute = "Route";
export const txtServiceRequestDetails = "Service Request Details";
export const txtUpdateServiceRequest = "Update Service Request";
export const txtServiceRequestStatus = "Service request status";
export const txtSearchProConfirmation = "Are you sure to search for another professional?";
export const txtClosed = "Closed";
export const btnCancelRequest = "Cancel Request";
export const btnCancel = "Cancel";
export const txtOopsInconvenienceTryLater = "Oops! Sorry for the inconvenience, Please try after some time.";
export const txtUnableToLocateProfessional = "We appologize but we are unable to locate a professional right now. We will continue trying and will notify you when one becomes available. Thank you.";
export const txtGetBackProfessionalAsPreferred = "Our Professional will get back to you at your preferred time slot.";
export const txtThankCreatingService = "Thank you for creating service request.";
export const txtConnectingToProPleaseWait = "Please wait, we are finding the best professional for you.";
export const txtConnectingToProBePatient = "Please be patient while we search for an online %@ professional to assist you.";
export const txtHomeIntro = "Chilll connects people and repair professionals through AI enabled video chat, Pro's can now help customers virtually through a smart phone or a tablet.";
export const btnJobs = "My jobs";
export const btnAdmin = "Admin";
export const btnSuperAdmin = "Super Admin";
export const btnNo = "No";
export const btnYes = "Yes";
export const txtLogoutConfirmation = "Are you sure you want to sign out of your Chilll account?";
export const txtApplicationName = "Chilll";
export const btnNoThanks = "No Thanks";
export const btnRegister = "Register";
export const txtRegisterAs = "Register as";
export const btnScan = "SCAN DEVICE";
export const btnUploadImage = "UPLOAD IMAGE";
export const btnRecognize = "Recognize The Device";
export const hintProductDescription = "Product Description";
export const hint_zip_code = "Zip code (optional)";
export const txtZipCode = "Zip code";
export const hintCommunicationMode = "Best Contact Method";
export const hintTimeSlot = "Best time to contact";
export const lblTitlePhotos = "Photos";
export const txtProductDescription = "Problem description";
export const txtCommunicationMode = "Best Contact Method";
export const txtTimeSlot = "Best Time To Contact";
export const txtJobDetails = "Job Details";
export const txtMyRequests = "My Requests";
export const txtProblemNotSpecified = "Problem description not specified";
export const txtRequestDetails = "Service Details";
export const hintSearch = "Search here...";
export const textSearch = "Search";
export const txtYourFeedback = "Your feedback (optional)";
export const hindSendFeedback = "We love feedback. What do you like and dislike about this screen?";
export const txtMobileNumber = "Phone Number";
export const txtNotificationDetails = "Notification Details";
export const btnGoBack = "Go Back";
export const btnOk = "Ok";
export const btnGotIt = "GOT IT";
export const txtDate = "Date";
export const btnSaveAndSend = "Save & Send";
export const txtDeleteAccounConfirmation = "Are you sure want to delete this account?";
export const txtCamera = "Take Photo";
export const txtAvatar = "Use Avatar";
export const txtDeleteRecordConfrimation = "Are you sure want to delete this record?";
export const txtReadAllNotificationsConfrimation = "Do you want to read all notifications?";
export const btnLoginHere = "Login here";
export const btnAlreadyAUser = "ALREADY HAVE AN ACCOUNT?";
export const hintHomeAddress = "Home address";
export const hintWorkAddress = "Work Address";
export const btnAddExpertise = "Add Expertise";
export const txtDocuments = "Documents";
export const txtLicenceDocument = "Licence Document";
export const txtAddressDocument = "Address Document";
export const txtInsuranceDocument = "Insurance Document";
export const txtRegisteredUsers = "Registered Users";
export const txtUserInfo = "User Info";
export const txtUsersFeedback = "Users Feedback";
export const btnResolve = "Resolve";
export const btnContactUs = "Contact Us";
export const btnPersonal = "Personal Info";
export const btnPersonalInfo = "Personal Info";
export const btnSwitchProfile = "Switch Role";
export const btnSendFeedback = "Send Feedback";
export const btnCloseTicket = "Close Ticket";
export const btnCompleteService = "Complete Service";
export const btnReinitiateService = "Reinitiate Service";
export const btnNotUser = "DON'T HAVE A CHILLL ACCOUNT?";
export const btnRegisterHere = "Register here";
export const btnOpenSettings = "Open Settings";
export const btnNotNow = "Not Now";
export const btnAllow = "Allow";
export const btnDeny = "Deny";
export const hintDrawingText = "Enter Text and then select an area to pin the text.";
export const hintEnterText = "Enter text here.";
export const txtSavedToFiles = "Save To Files";
export const txtSavedToPhotos = "Save To Photos";
export const txtSavedToCallNotes = "Save To Call Notes";
export const txtSortBy = "Sort By";
export const txtResetPassword = "Change your password";
export const btnUpdate = "Update";
export const btnUpdateNow = "Update Now";
export const txtCustomer = "Customer";
export const txtProfessional = "Professional";
export const txtAdmin = "Admin";
export const txtSuperAdmin = "Super Admin";
export const hintFullName = "Full Name";
export const btnSendAsAnonymous = "Send as anonymous";
export const btnCustomer = "Customer (I need things fixed)";
export const btnProfessional = "Pro/Support (I fix things)";
export const txtProWaiting = "Waiting for professional to join";
export const txtCustomerWaiting = "Waiting for customer to join";
export const txtAmountToPay = "Amount to pay -";
export const txtImageVideo = "Image or Video";
export const txtRequestTimeout = "Request timeout";
export const txtSomethingWrong = "Something went wrong! Please try after some time.";
export const txtTooManyRequest = "Too many request, please retry after some time.";
export const txtTokenExpired = "Refresh token has expired!, please re-login.";
export const btnSignUp = "SIGN UP";
export const btnSignIn = "SIGN IN";
export const btnResendCode = "Resend Code";
export const btnTermsConditions = "Terms & Conditions";
export const btnDeleteAll = "Delete All";
export const btnReScan = "RE-SCAN";
export const btnIdentifyManually = "IDENTIFY MANUALLY";
export const btnDiscard = "Discard";
export const btnOpen = "Open";
export const btnPreview = "Preview";
export const btnVerify = "Verify";
export const btnPay = "Pay";
export const btnEdit = "Edit";
export const btnAddAttachments = "Add Attachments";
export const btnSendInvite = "Send Invite";
export const btnSendRequest = "Send Request";
export const btnGetStarted = "GET STARTED";
export const btnLoginSignup = "LOG IN OR SIGN UP";
export const txtLoginSignup = "Log In or Sign Up";
export const txtSkip = "Skip";
export const txtDocument = "Choose Document";
export const txtPayment = "Payment";
export const txtZTOA = "Z - A";
export const txtATOZ = "A - Z";
export const txtOld = "Oldest";
export const txtLatest = "Latest";
export const txtSelectLanguage = "Select Language";
export const txtSessionExpire = "Session Expired!!!";
export const txtMobileNo = "Mobile No.";
export const txtChilllCompany = "Powered by Chilll";
export const txtCopyrightChilll = "Copyright © 2022 Chilll";
export const txtNointernet = "No Internet";
export const txtExpertiseInfo = "Expertise Info";
export const txtPopupSearchCountry = "Search Country";
export const txtPopupSearchState = "Search State";
export const txtPopupSearchCity = "Search City";
export const txtTabBarLblCallHistory = "Call History";
export const txtPrivacyPolicy = "Privacy Policy";
export const txtTermsConditionsSettings = "Terms and Services";
export const txtLblSortByDate = "Sort by date :";
export const txtUserRole = "User Role";
export const txtWaitingUser = "Waiting Users";
export const txtRepairDiagnosis = "Repair Diagnosis";
export const txtCheckValidationCodeOn = "A verification code as been sent to your %@";
export const txtSearchProfessional = "Search Professional";
export const txtProName = "Pro Name";
export const txtRepairSuggession = "Repair Suggession";
export const txtToolsSupplies = "Tools & Supplies needed for repair";
export const txtEstimatedCost = "Estimated cost of repair";
export const txtProblemDescription = "Problem Description";
export const txtVerification = "Enter Verification Code";
export const txtAdditionalInfo = "Additional Information";
export const txtTitleSubTitle = "Please provide your Preferences like your availability and communication mode";
export const hintEnterValidationCode = "Verification code (4 digits)";
export const hintProductModelNo = "Product Model No";
export const hintTotalWorkExperience = "Total Work Experience";
export const hintCardHolderName = "Card Holder Name";
export const hintCardNumber = "Card Number";
export const hintCVV = "CVV";
export const hintMonth = "Expiration Month";
export const hintYear = "Expiration Year";
export const validationEmptyCardNumber = "Please enter card number.";
export const validationValidCardNumber = "Please enter 16 digit card number.";
export const validationValidStripeCardNumber = "Please enter valid card number.";
export const validationEmptyCvv = "Please enter CVV.";
export const validationValidCvv = "Please enter minimun 3 digit CVV.";
export const validationSelectMonth = "Please select expiry month.";
export const validationSelectYear = "Please select expiry year.";
export const validationEmphtyExpiry = "Please enter expiry month and year (mm/yy).";
export const validationValidExpiry = "Please enter a valid expiry month and year.";
export const hintSearchByName = "Search here by name...";
export const btnTicketDetails = "Ticket Details";
export const txtServiceRequestFollowUp = "Service Request Follow-up";
export const txtSendFeedback = "Feedback";
export const txtCreateAccount = "Create Account";
export const txtRegisterCompany = "Business Registration";
export const txtCompanies = "Companies";
export const txtCompanyName = "Business Name";
export const txtCompanyEmail = "Business Email";
export const txtCompanyMobileNumber = "Business Phone Number";
export const txtCompanyAddress = "Business Address";
export const hintCompanyName = "Enter Business Name";
export const hintCompanyEmail = "Enter Business Email";
export const hintCompanyMobileNumber = "Enter Business Phone Number";
export const hintCompanyAddress = "Select Business Address";
export const errorCompanyName = "Please enter a valid business name.";
export const errorCompanyAddress = "Please select a business address.";
export const errorCompanyEmail = "Please enter a valid business email.";
export const errorCompanyMobileNumber = "Please enter a valid business phone number.";
export const txtMyCompany = "My Business";
export const txtAccountInfo = "Account info";
export const txtAccountInfoSubHeading = "Please introduce yourself and tell us your zip code so that we can display the information correctly for you.";
export const txtCompanyDetails = "Business Details";
export const txtOwnerDetails = "Owner Details";
export const btnUploadPicture = "Upload Picture";
export const txtScanHelpUs = "Show Chilll what's broken...";
export const txtDescribeScanDeviceProblem = "Describe the %@ problem and we will connect you to a %@ professional to assist you.";
export const txtExampleDevices = "Example of %@ devices";
export const btnConnectMeTo = "Connect me to a %@ professional";
export const txtServiceRequestStep = "Service Request: Step %@ of %@";
export const btnTeamMembers = "Team Members";
export const txtCompanyAdmin = "Company Admin";
export const btnCompanyAdmin = "Company Admin";
export const btnAddTeamMember = "Add Team Member";
export const txtNotes = "Notes";
export const txtHomeIntroCustomer = "Connect with a Pro online and together you'll partner remotely to resolve your problem";
export const txtANewWay = "A new way to look at home repairs";
export const txtLoginSignUpScreenSubTitle = "We connect home service pros and customers by A.I. video to change how things get fixed";
export const txtNeedHelp = "Need help logging in?";
export const txtVerified = "Verified";
export const txtNotVerified = "Not verified! (Click here to verify)";
export const btnAdd = "Add";
export const txtCustomerHomeTitle = "Welcome to Chilll";
export const txtCustomerHomeSubTitle = "Connect with a Pro online and together you'll partner remotely to resolve your problem.";
export const btnCreateAServiceRequest = "CREATE A SERVICE REQUEST";
export const txtConnectToRemote = "Connect to a remote service pro to help diagnose, fix, install or maintain stuff in your place.";
export const txtGetRemoteHelp = "Get Remote Help";
export const txtRemoteHelpStep1 = "Scan the device";
export const txtRemoteHelpStep2 = "Connect to a remote Pro";
export const txtRemoteHelpStep3 = "Pro guides you to a solution";
export const txtLastCall = "Last Call";
export const txtNoCategory = "No category";
export const txtNoCallsYet = "No calls yet";
export const txtHelpCenter = "Help Center";
export const txtHomeCheckUp = "Home Check-Up";
export const txtNoMaintenanceTasks = "No maintenance tasks added";
export const btnCreateTasks = "Create tasks now";
export const txtMaintenanceTasksAdded = "Maintenance tasks added, %@ need action in %@ days";
export const txtAddListItem = "Add list item";
export const txtEditListItem = "Edit list item";
export const txtListItemDetails = "List item details";
export const txtRemoveListItem = "Remove list item";
export const txtAddNote = "Add note";
export const txtEditNote = "Edit note";
export const btnOCR = "OCR";
export const btnObjectRecognition = "Object Recognition";
export const btnMeasure = "Measure";
export const btnDrawing = "Drawing";
export const txtMore = "More";
export const txtMoreSubHeading = "More Features";
export const txtOpenJobs = "Open Jobs";
export const txtAllJobs = "All Jobs";
export const txtReadyForJobs = "Accepting Jobs";
export const txtPauseJobs = "Jobs Paused";
export const txtOutOfStars = "%@ out of %@ stars";
export const txtGiveARating = "Give a Rating";
export const txtTipsAndTricks = "Tips And Tricks";
export const hintWriteHere = "Write here";
export const txtAddRatingComment = "Add comment for your rating";
export const txtSignUpTitle = "Chilll Sign-up";
export const txtSignUpSubTitle = "You're moments away from changing the way things get fixed";
export const txtThisWillLoginId = "(This will be your login ID)";
export const txtSendVideoLinkHeading = "It's easy to connect with a customer. Just enter their cell phone or email below and we'll send them a unique link to join you by video.";
export const txtCropScreenHeading = "Step 2 of 3. Focus on broken device only";
export const txtRecognizeOptionsHeading = "Choose any one from below following options";
export const msgYouHaveNoNotifications = "You Have No Notifications At This Time Thank You";
export const msgNoNotifications = "No Notifications";
export const role_required = "Please select user role type";
export const enterFullName = "Please enter full name.";
export const validFullName = "Please enter valid full name";
export const enterFirstName = "Please enter first name";
export const enterLastName = "Please enter last name";
export const validFirstName = "First name must be at least 3 characters long.";
export const validLastName = "Last name must be at least 3 characters long.";
export const validEmailText = "Please enter a valid email.";
export const validMobileNumberText = "Please enter a valid phone number";
export const validEmail_OR_MobileNumberText = "Please enter a valid email or phone number.";
export const validPassword = "Please enter a password";
export const validConfirmPassword = "Please enter a confirm password";
export const enterMessage = "Please enter a message";
export const validMessage = "Please enter a valid message";
export const validMessageLengthText = "Message must be atleast 8 characters long";
export const passwordLengthText = "Please enter valid password between 8-20 characters and must contain atleast one special character, one capital letter, one small letter and one number.";
export const confirmPasswordLengthText = "Confirm Password must be atleast 8 characters long";
export const passwordNotMatchText = "Password and confirm password not matched";
export const validCurrentPasswordText = "Current password is required.";
export const validConfirmationCode = "Please enter a valid confirmation code";
export const acceptTermsCondition = "Please accept terms and conditions";
export const validCompanyName = "Please select a valid company name.";
export const enterCompanyName = "Please enter a valid company name.";
export const validTotalWorkExp = "Please enter a total work experience";
export const validWorkEmailText = "Please enter a valid work email";
export const validWorkMobileNumberText = "Please enter a valid work phone number.";
export const validWorkEmail_OR_MobileNumberText = "Please enter a valid work email or phone number.";
export const validWorkAddress = "Please select a work address";
export const expertiseName = "Please enter a expertise name.";
export const expertiseCompetency = "Please select a expertise competency.";
export const workExperience = "Please enter work experience.";
export const enterProductDescription = "Please enter a product description";
export const enterProblemDescription = "Please enter a problem description.";
export const validProName = "Please enter a professional name.";
export const validRepairSuggession = "Please enter a repair suggession";
export const validToolsSupplies = "Please enter a tools & Supplies needed for repair.";
export const validEstimatedCost = "Please enter a estimated cost of repair";
export const validProblemDescription = "Please enter a problem description.";
export const pleaseUploadDoc = "Please upload your documents here";
export const errEmptyEmailOrPhone = "An email or phone number is required.";
export const errEmptyPassword = "Password is required.";
export const validNewPassword = "New password is required.";
export const errorEmptyEmail = "An email is required.";
export const errorEmptyMobileNumber = "An phone number is required.";
export const btnLogin = "LOG IN";
export const btnJoinWaiting = "Join Waiting List";
export const btnRemember = "Remember Me";
export const btnForgotPassword = "Forgot your password?";
export const txtSortByDate = "Sort by date :";
export const txtAllTickets = "All Tickets";
export const btnTermServices = "I accept the Terms & Conditions";
export const btnSendCode = "Send Code";
export const btnSubmit = "SUBMIT";
export const btnSave = "Save";
export const btnTopUp = "Top Up";
export const btnWithdraw = "Withdraw";
export const btnHome = "Home";
export const btnConnect = "Connect to Customer";
export const btnConnectToPro = "Connect to Pro";
export const btnConnectToCustomer = "Connect to Customer";
export const btnTickets = "Tickets";
export const btnOpenJobs = "Open Jobs";
export const btnAssigned = "Assigned ";
export const btnCompleted = "Completed";
export const btnAccept = "Accept Job";
export const btndecline = "Decline Job";
export const btnRead = "Read All";
export const btnDelete = "Delete";
export const btnDeleteAccount = "Delete account";
export const btnTurnOff = "Turn Off Notifications";
export const btnSetting = "Setting";
export const btnChangePassword = "Change Password";
export const btnAboutUs = "About Us";
export const btnContact = "Contact Us";
export const btnInviteFriends = "Invite Friends";
export const label = "label";
export const btnLogout = "Log out";
export const btnYesLogout = "Yes, log out";
export const btnBio = "Bio";
export const btnWorkInfo = "Work Info";
export const btnDocuments = "Documents";
export const btnSaveWork = "Save Work Info";
export const btnInvite = "Send invitation";
export const btnFree = "Free";
export const btnviewAll = "View All Jobs";
export const btnChoose = "Choose File";
export const btnUpload = "Upload Documents";
export const btnInProgress = "In Progress";
export const btnDone = "Done";
export const btnDecline = "Decline";
export const btnJoinVideo = "Join Video";
export const btnResendLink = "ResendLink";
export const btnDiagnosisReport = "Create Diagnosis Report";
export const btnSendLink = "Send Link";
export const btnFlashOnOff = "Flash On/Off";
export const btnMuteUnmute = "Mute/Unmute";
export const btnSwitchCamera = "Switch Camera";
export const btnZoomIn = "Zoom-In";
export const btnZoomOut = "Zoom-Out";
export const btnZoomReset = "Zoom-Reset";
export const btnDraw = "Draw";
export const btnUserHighlight = "User Highlight";
export const btnClear = "Clear";
export const btnDownload = "Download";
export const btnGoLive = "Go Live";
export const btnUpdateProfile = "Update Profile";
export const btnUpdateProfileLoading = "Updating...";
export const btnSaveWorkLoading = "Saving info";
export const btnSaveExpertise = "Save Expertise";
export const btnSaveExpertiseLoading = "Saving...";
export const btnAddBank = "Add Bank";
export const btnAvailableServices = "Available Services";
export const btnMyServices = "My requests";
export const btnCheckWaitingUsers = "Check Waiting Users";
export const btnAddUser = "Add User";
export const btnFeedback = "Feedback";
export const btnConnectWithPro = "Connect with Pro";
export const btnConnectWithAnotherPro = "Connect with another Pro";
export const btnReInititateService = "Re-initiate service";
export const btnReInititateLoading = "Re-initiating...";
export const btnMarkAsResolved = "Mark as Resolved";
export const btnAcceptService = "Accept";
export const btnRejectService = "Reject";
export const btnRejectedService = "Rejected";
export const btnRejectedServiceMsg = "You have rejected request";
export const btnAcceptedByotherPro = "Accepted By other Professional";
export const alertCameraAccessDenied = "Camera access is denied!";
export const alertAllowAccessToCamera = "Allow access to camera, go to your settings and tap Camera. Application will be restart when changed the settings.";
export const alertAllowAccessToPhotos = "Allow access to your photos.";
export const alertPhotosPermission = "This lets you share from your camera roll and enables other features for photos and videos. Go to your settings and tap Photos.";
export const alertScreenshotSavedMessage = "Screenshot has been saved to your photos.";
export const alertScreenshotSavedMessageError = "Save error";
export const alertMicrophoneAccessDenied = "Microphone access is denied!";
export const alertAllowAccessToMicrophone = "Allow access to microphone, go to your settings and tap Microphone. Application will be restart when changed the settings.";
export const alertTorchUnavailable = "Device torch is currently unavailable, maybe the device overheats and needs to cool off.";
export const alertTorchUnavailableOnFrontCamera = "Device torch mode is currently unavailable for front camera.";
export const alertTurnOnCamera = "Please turn on your camera first then retry.";
export const alertNoParticipation = "Remote participant not available into the room or join the video call.";
export const alertCantDisableVideo = "You can't turn off your camera because professional is drawing.";
export const alertCantStartDrawingOnDisableVideo = "You can't start or stop drawing because remote participant camera is turn off.";
export const alertCantStartDrawingOnNoParticipation = "You can't start drawing because remote participant is not available into room.";
export const alertCantDoUserHighlighWhenProDrawing = "You can't do the user highlight because professional is drawing.";
export const alertDrawingSavedToFiles = "Drawing has been saved to your files.";
export const alertDrawingSavedToPhotos = "Drawing has been saved to your photos.";
export const alertDrawingSavedToCallNotes = "Drawing has been saved to call notes under call history.";
export const alertSnapshotSavedToPhotos = "Snapshot has been saved to your photos.";
export const alertSnapshotSavedToCallNotes = "Snapshot has been saved to call notes.";
export const alertRestrictedSendEvents = "You can't send contoll event becasue remote participant camera is turn off.";
export const alertDrawingStarted = "Pro has paused your screen to draw.";
export const alertDrawingStoped = "Professional has stopped drawing.";
export const alertDrawingCleared = "Professional has erased the drawing.";
export const validMinimumRating = "Minimum rating should be 1 star.";
export const alertDiscardRecording = "Screen recording is enabled, do you want to save or discard?";
export const alertLindedExpired = "Link is expired, can't able to join video.";
export const alertNoInternet = "Please try again after some time.";
export const alertUnableToPickFile = "Unable to pick file";
export const alertConfrimationDeleteAllRecord = "Are you sure want to delete all records?";
export const alertConfrimationDeleteAttachment = "Are you sure want to delete this attachment?";
export const alertNewVersion = "New version of App is available. Please download from app store.";
export const alertEmptyFullname = "Please enter full name.";
export const alertDeleteCompanyConfirmation = "Are you sure want to delete this company?";
export const alertNoOpenJobsFound = "Currently no jobs waiting to be accepted. Click the Jobs Paused button above and get real time jobs.";
export const txtVideoChatConnection = "Video Chat Connection";
export const txtInvitationSent = "invitation sent";
export const txtAcceptServiceRequests = "Accept Service Requests";
export const txtEarnings = "Earnings";
export const txtLastMonth = "Last month";
export const txtAccept = "Accept";
export const txtDecline = "Decline";
export const lblLoginTitle = "Log in to Chilll";
export const lblSignUpTitle = "Sign Up to Chilll as";
export const txtRoleCustomerTitle = "I’m a customer";
export const txtRoleCustomerSubTitle = "I need things fixed";
export const txtRoleProTitle = "I’m a Pro";
export const txtRoleProSubTitle = "I fix things";
export const lblSignInAs = "You log in using";
export const lblSignUpAs = "You're signed up as";

